import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Alert,
  Box,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  ListItemText,
  MenuItem,
  MenuList,
  Stack,
  Typography,
} from '@mui/material';

import useSubscriber from '@hooks/useSubscriber';

const SwapDeviceDialog: FC = () => {
  const { t } = useTranslation();
  const { deviceList, handleSelectDevice, cancelLogin, remainingSwaps } = useSubscriber();

  return deviceList ? (
    <Dialog fullWidth maxWidth='xs' onClose={cancelLogin} open>
      {remainingSwaps && remainingSwaps > 0 ? (
        <Fragment>
          <DialogTitle>{t('subscriber.login.replaceDevice.title')}</DialogTitle>
          <Box component={DialogContent} pt={0}>
            <Typography gutterBottom>
              {t('subscriber.login.replaceDevice.description', {
                deviceCount: deviceList.length,
                count: remainingSwaps,
              })}
            </Typography>

            <Stack component={MenuList} spacing={1.5}>
              {deviceList.map(device => (
                <Card
                  component={MenuItem}
                  key={device.deviceId}
                  onClick={() => handleSelectDevice(device.deviceId)}
                  title={JSON.stringify(device, null, 2)}
                >
                  <ListItemText primary={device.deviceName} secondary={device.deviceId} />
                </Card>
              ))}
            </Stack>
          </Box>
        </Fragment>
      ) : (
        <Fragment>
          <DialogTitle>{t('subscriber.login.noRemainingSwaps.title')}</DialogTitle>
          <Box component={DialogContent} pt={0}>
            <Alert>{t('subscriber.login.noRemainingSwaps')}</Alert>
          </Box>
        </Fragment>
      )}
    </Dialog>
  ) : null;
};

export default SwapDeviceDialog;
